import { Slider } from 'antd';
import SliderTooltip from 'antd/es/slider';
export { SliderTooltip };
export default Slider;
